module.exports = __webpack_public_path__ + "static/img/purchase3.331b67eb.png";